/* global axios */

import ApiClient from './ApiClient';

class TemplateHeaderMediaAPI extends ApiClient {
  constructor() {
    super('template_header_media', { accountScoped: true });
  }

  upload(file, headerFormat, { templateName = '', language = '' } = {}) {
    const data = new FormData();
    data.append('file', file);
    data.append('header_format', headerFormat);
    if (templateName) {
      data.append('template_name', templateName);
      data.append('language', language || '');
    }
    return axios.post(this.url, data);
  }

  // Header media already hosted for this template (null when never uploaded).
  savedAsset({ templateName, language, headerFormat }) {
    return axios.get(this.url, {
      params: {
        template_name: templateName,
        language: language || '',
        header_format: headerFormat,
      },
    });
  }
}

export default new TemplateHeaderMediaAPI();
